import React, { Component } from "react";
import { connect } from 'react-redux';
import { MapContainer, TileLayer, WMSTileLayer, LayersControl } from 'react-leaflet'
import BanDoVietNam from "../../../routes/BanDo/TraCuuTNN/BanDoVN"
import GeoJson_Layer_MT from "../GeoJson_traCuu/GeoJson_Layer_MT";
import ReactLeafletGoogleLayer from 'react-leaflet-google-layer';
import Geocode_gg from "../../../helper/geocode_gg";
class MiniMap extends Component {
    constructor(props) {
        super(props);
        const { functions } = props;
        this.state = {
            center: [16.371824, 107.549195]
        }
    }

    componentDidMount() {
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

    }

    FlyToButton = (latlong) => {
        this.setState({
            center: latlong
        })
    }

    render() {
        const { center } = this.state
        const { user, dulieu, loai } = this.props

        return (
            <div id="mapid" style={{ height: window.innerHeight / 2, margin: "-10px" }} key={center}>
                <MapContainer center={center} zoom={13} style={{ height: '100%' }}>
                    <LayersControl position="topright">
                        <BanDoVietNam opacity={0}/>
                        <LayersControl.Overlay checked name="Google map vệ tinh (Tham khảo)">
                            <ReactLeafletGoogleLayer apiKey='AIzaSyDIzUBPS7VQFZa39WmfblASa45GOU86JIc' type={'hybrid'} zIndex='4' />
                        </LayersControl.Overlay>
                        <Geocode_gg />
                    </LayersControl>
                    {dulieu && loai && <GeoJson_Layer_MT dulieu={dulieu} loai={loai} zoomOut={(latlong) => this.FlyToButton(latlong)} />}
                </MapContainer >
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    user: state.oidc.user,
    functions: state.functions
});

export default connect(mapStateToProps)(MiniMap);
